import {
  Button,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import { MobileDatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import React, { useContext, useState } from "react";
import DateLocalizationProvider from "../../../../components/element/DateLocalizationProvider";
import SearchAirlineDialog from "../../../../components/element/SearchAirlineDialog";
import { DATE_FORMAT } from "../../../../utils/constants";
import "../css/ConfessionFee.css";
import { useFormData } from "../../../../helpers/FormDataProvider";
import { StorageContext } from "../../../../services/StorageProvider";

const ConcessionFilter = ({
  onClickClear,
  onClickApply,
  onAirlineChange,
  selectedAirline,
}) => {
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [selectedInvoiceDate, setSelectedInvoiceDate] = useState(null);
  const [showSearchAirlineDialog, setShowSearchAirlineDialog] = useState(false);
  const { userData } = useFormData();
  const { associatedAirlineData } = useContext(StorageContext);

  const handleInvoiceNumberChange = (event) => {
    setInvoiceNumber(event.target.value);
  };

  const handleInvoiceDateChange = (newValue) => {
    setSelectedInvoiceDate(newValue);
  };

  const handleClearFilter = () => {
    setInvoiceNumber("");
    setSelectedInvoiceDate(null);
    onClickClear();
  };

  const handleSearchAirlineChange = (airline) => {
    onAirlineChange(airline);
  };
  const handleAirlineChange = (event) => {
    const selectedId = event.target.value;
    const selectedAirline = associatedAirlineData?.data?.find(
      (airline) => airline.id === selectedId
    );
    onAirlineChange(selectedAirline);
  };
  return (
    <div className="concession-fee-filter-container">
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <FormControl variant="outlined">
                <div className="concession-fee-filter-header">Airline</div>
                {userData?.isAAUser ? (
                  <div
                    className="concession-fee-filter-select-airline"
                    onClick={() => setShowSearchAirlineDialog(true)}
                  >
                    {selectedAirline ? (
                      <p>{selectedAirline?.airlineName}</p>
                    ) : (
                      <span className="placeholder-text">Select</span>
                    )}
                  </div>
                ) : (
                  <Select
                    id="concession-fee-filter-select-airline"
                    className="concession-fee-filter-select-container"
                    value={selectedAirline?.id || ""}
                    onChange={handleAirlineChange}
                    displayEmpty
                    renderValue={(selected) =>
                      selected ? (
                        associatedAirlineData?.data?.find(
                          (airline) => airline?.id === selected
                        )?.airlineName
                      ) : (
                        <span className="placeholder-text">Select</span>
                      )
                    }
                  >
                    {associatedAirlineData?.data?.map((airline) => (
                      <MenuItem key={airline?.id} value={airline?.id}>
                        <ListItemText primary={airline?.airlineName} />
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined">
                <div className="concession-fee-filter-header">Customer ID</div>
                <input
                  name="concession-fee-filter-invoice-number"
                  value={invoiceNumber}
                  onChange={handleInvoiceNumberChange}
                />
              </FormControl>
            </Grid>

            <DateLocalizationProvider>
              <Grid item>
                <FormControl variant="outlined">
                  <div className="concession-fee-filter-header">
                    Submission Date
                  </div>
                  <MobileDatePicker
                    id="concession-fee-filter-departure-datepicker"
                    className="concession-fee-filter-datepicker"
                    format={DATE_FORMAT}
                    maxDate={dayjs()}
                    value={selectedInvoiceDate}
                    onChange={handleInvoiceDateChange}
                  />
                </FormControl>
              </Grid>
            </DateLocalizationProvider>
          </Grid>
        </Grid>

        <Grid item>
          <div className="concession-fee-filter-button-container">
            <Button className="clear" onClick={handleClearFilter}>
              Clear
            </Button>
            <Button
              variant="contained"
              color="secondaryButton"
              onClick={() =>
                onClickApply(
                  invoiceNumber,
                  selectedInvoiceDate,
                  selectedAirline
                )
              }
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>
      <SearchAirlineDialog
        open={showSearchAirlineDialog}
        onClose={() => setShowSearchAirlineDialog(false)}
        onSelectAirline={handleSearchAirlineChange}
      />
    </div>
  );
};

export default ConcessionFilter;
